
import React from "react";

export const SessionDataManagedNotice: React.FC = () => (
  <div
    role="status"
    className="w-full rounded-md border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900"
  >
    We automatically sync these sessions to match your publicly announced sessions, so manual
    edits may be overwritten. If you prefer to manage them yourself, email
    support@kidsbooked.com
  </div>
);
